<a href="#">
  <op-icon icon-classes="icon-show-more-horizontal"></op-icon>
</a>
